import { GzPolicyUiSettingsGridDataProvider } from '../../../../../../../common/policyPanel/uiSettings/gridTemplate/gridComponents/gridView/dataProvider/GzPolicyUiSettingsGridDataProvider';
import { Column, ColumnKeys } from './grid-config';
import { SetFiltersRequest } from '../../../../../../../../grid/types/common';
import {
  convertRegexFilterToBooleanFilter,
  convertRegexFilterToStartsWithFilter,
} from '../../../../../../../common/policyPanel/uiSettings/gridTemplate/utils/filters-converters';
import {
  ExchangeRuleScopeApplyToType,
  ExchangeRuleScopeEmailSelection,
  ExchangeContentControlFilteringRule,
} from '@nirvana/shared/dtos/types/policies/common';

export interface ExchangeContentControlFilteringRuleFrontendFields extends ExchangeContentControlFilteringRule {
  applyTo: ExchangeRuleScopeApplyToType;
  senders: ExchangeRuleScopeEmailSelection;
  recipients: ExchangeRuleScopeEmailSelection;
}

export class GzExchangeContentControlContentFilteringRulesGridDataProvider extends GzPolicyUiSettingsGridDataProvider<
  Column,
  ColumnKeys,
  ExchangeContentControlFilteringRule
> {
  async setFilters(request: SetFiltersRequest<ColumnKeys>): Promise<{} | undefined> {
    // convert to boolean
    convertRegexFilterToBooleanFilter(request, ColumnKeys.STATUS);

    // convert regex to startsWith
    convertRegexFilterToStartsWithFilter(request, ColumnKeys.NAME);
    return;
  }

  protected getItemsWithAdditionalFrontendFields(
    items: ExchangeContentControlFilteringRule[]
  ): ExchangeContentControlFilteringRuleFrontendFields[] {
    return items.map(item => {
      return {
        ...item,
        applyTo: item.scope.applyTo,
        senders: item.scope.from,
        recipients: item.scope.to,
      };
    });
  }
}
